import { render, staticRenderFns } from "./ImportChooseMethod.vue?vue&type=template&id=4222248c&scoped=true&"
import script from "./ImportChooseMethod.vue?vue&type=script&lang=js&"
export * from "./ImportChooseMethod.vue?vue&type=script&lang=js&"
import style0 from "./ImportChooseMethod.vue?vue&type=style&index=0&id=4222248c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222248c",
  null
  
)

export default component.exports